import { MdChevronLeft } from "react-icons/md";
import styles from "../style";
import { Reveal } from "./reveal";
import { FiArrowUp } from "react-icons/fi";
import { LogoIcon } from "../assets";

const Heroabout = () => {
  return (
    <div className={`${styles.flexCenter} bg-fourth min-h-screen w-full`}>
      <div className={`w-full justify-center items-start flex flex-col md:flex-row pt-40 px-10 md:gap-20 gap-10`}>  
        <Reveal className="flex flex-col gap-4 items-start md:items-end">
          <h2 className="text-sm font-semibold text-primary py-2">
            About Us
          </h2>
        </Reveal>
        
        <div className="flex flex-col gap-4 items-start">
          <Reveal>
            <div className={`flex flex-col items-start`}>
              <p className={`text-primary xs:text-md text-mm text-start my-2 max-w-[800px]`}>
                At Aegis Education Group, we provide consultancy led training and advisory support to help schools move from policy awareness to confident, consistent day to day practice.
              </p>
    
              <p className={`text-secondary xs:text-mm text-sm text-start my-6 max-w-[800px]`}>
                Aegis Education Group was founded by Emilianne Gathitu, a school leader, educator and safeguarding practitioner with international school experience across teaching, leadership, safeguarding, staff development and systems improvement.
              </p>
    
              <span className="xs:mb-6 border-b border-2 border-second w-[100px]"></span>         
            </div>        
          </Reveal>
        </div>     
      </div>
    </div>
  );
};

export default Heroabout;
